import { render, staticRenderFns } from "./groups-layout.vue?vue&type=template&id=f7501c28&scoped=true&"
import script from "./groups-layout.vue?vue&type=script&lang=js&"
export * from "./groups-layout.vue?vue&type=script&lang=js&"
import style0 from "./groups-layout.vue?vue&type=style&index=0&id=f7501c28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7501c28",
  null
  
)

export default component.exports